// Member rewards (docs/prd-member-rewards.md). Amounts are fixed in code; changing
// them is a code change, not an admin setting.

/** Friend's discount when paying with a member's promo code (cents). */
export const MEMBER_CODE_DISCOUNT_CENTS = 500;

/** Store credit granted to the member once the friend's order completes (cents). */
export const MEMBER_REWARD_CENTS = 500;

/** An in-person order completes this many hours after its session ends. */
export const MEMBER_REWARD_DELAY_HOURS = 24;

/** Invite emails one member may send per rolling 24 hours. */
export const MEMBER_INVITE_DAILY_LIMIT = 20;

/** A member's invite reaches the same address at most once per this many days. */
export const MEMBER_INVITE_REPEAT_DAYS = 7;

/** How long a promo code from a shared link is remembered in the browser. */
export const MEMBER_CODE_REMEMBER_DAYS = 30;

/** Query parameter that carries a member's promo code on shared links. */
export const MEMBER_CODE_QUERY_PARAM = 'ref';
